import {http} from '../core/http';

export const roleService = {
  getAllRoles() {
    return http.post('/uss/get_allroles', {});
  },

  getDirectoryRoles(params: { directory_id: number | string }) {
    return http.post('/uss/get_directory_roles', params);
  },

  createRel(params: { role_id: string; directory_id: number | string }) {
    return http.post('/uss/create_rel', params);
  },

  updateRel(params: { id: number | string; role_id: string; directory_id: number | string }) {
    return http.post('/uss/update_rel', params);
  },

  deleteRel(params: { id: number | string }) {
    return http.post('/uss/delete_rel', params);
  },
};